/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Payment_Installments_RangeInputs */

const en_clients_validation_payment_installments_range = /** @type {(inputs: Clients_Validation_Payment_Installments_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a whole number between 0 and 999.`)
};

const pt_br2_clients_validation_payment_installments_range = /** @type {(inputs: Clients_Validation_Payment_Installments_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um número inteiro entre 0 e 999.`)
};

/**
* | output |
* | --- |
* | "Enter a whole number between 0 and 999." |
*
* @param {Clients_Validation_Payment_Installments_RangeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_payment_installments_range = /** @type {((inputs?: Clients_Validation_Payment_Installments_RangeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Payment_Installments_RangeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_payment_installments_range(inputs)
	return pt_br2_clients_validation_payment_installments_range(inputs)
});